import { ProcessDeUtil } from '../../domain/process-de-util';
import { WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { SmsMessageTemplate } from '../sms-message-template/sms-message-template';
import { MessageReceiver } from './message-receiver';

export class MessageNotice {

    id: string;
    /**
     * 消息内容
     */
    content: string;

    /**
     * 消息发送时机
     */
    sendTime: string;

    /**
     * 消息发送方式
     */
    sendType: string;

    /**
     * 消息主题
     */
    subject: string;

    /**
     * 消息接收人
     */
    receiver: string;

    /**
     * 消息接收人显示
     */
    receiverText: string;

    /**
     * 接收人列表
     */
    receivers: Array<MessageReceiver> = new Array();

    smsMessageTemplate: SmsMessageTemplate

    constructor() {
        this.id = ProcessDeUtil.GenerateElementId();
        this.subject = '消息通知';
        // this.sendType = 'email';
        this.content = `{"expr":"\'您有一条消息通知。\'","sexpr":""}`;
    }
}
// 2023-8-21 由于需要实现国际化，此处定义不能提取；
// export const processSendTime = [
//     { value: 'PROCESSINSTANCE_COMPLETED', text: this.localePipe.transform('component.MessageNotice.procComplete') },
//     { value: 'PROCESSINSTANCE_ABORTED', text: this.localePipe.transform('component.MessageNotice.procAborted') },
//     { value: 'PROCESSINSTANCE_ROLLBACK', text: this.localePipe.transform('component.MessageNotice.procRollBack') }
// ];

// export const activitySendTime = [
//     { value: 'WORKITEM_CREATED', text: this.localePipe.transform('component.MessageNotice.workCreated') },
//     { value: 'ACTIVITY_COMPLETED', text: this.localePipe.transform('component.MessageNotice.actComplete') },
//     { value: 'ACTIVITY_ABORTED', text: this.localePipe.transform('component.MessageNotice.actAborted') },
// ];

// export const sendTypes = [
//     { value: 'email', name: this.localePipe.transform('component.MessageNotice.email') },
//     { value: 'sms', name: this.localePipe.transform('component.MessageNotice.sms') },
//     { value: 'cloudplus', name: this.localePipe.transform('component.MessageNotice.cloudplus') }
// ];

// export const ReceiverType = [
//     { value: 'processParticipant', text: this.localePipe.transform('component.MessageNotice.processParticipant') },
//     { value: 'variableParticipant', text: this.localePipe.transform('component.MessageNotice.variableParticipant') },
//     { value: 'userParticipant', text:  this.localePipe.transform('component.MessageNotice.userParticipant') },
//     { value: 'positionParticipant', text:  this.localePipe.transform('component.MessageNotice.positionParticipant') },
// ];

// export const ProcessParticipantType = [
//     { value: 'procInstCreator', text: this.localePipe.transform('component.MessageNotice.procInstCreator') },
//     { value: 'workItemParticipant', text: this.localePipe.transform('component.MessageNotice.workItemParticipant') },
//     { value: 'activityExecutorParticipant', text: this.localePipe.transform('component.MessageNotice.activityExecutorParticipant') },
// ];


// export const VariableOrgTypes = [
//     { name: this.localePipe.transform('component.MessageNotice.sys'), value: 'Sys' },
//     { name: this.localePipe.transform('component.MessageNotice.administrative_organization'), value: 'Administrative_organization'} ]
